/**
 * Extend or overwrite the default PHONE_NUMBER configuration
 * @pattern ~~~/common/components/loginet-vue-shop/config/PhoneNumberConfig.js
 * It is recommended to use ENUM values, placed in and imported from ~/config/app-config.js
 */

export default {};
